import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import crmEnrichmentFiltersService from "../../../services/filters";
import type { CrmEnrichmentI18nKeys } from "../../../types/translations";
import type { CrmEnrichmentJobFilterType, CrmEnrichmentJobObject, Operator } from "../../../types/types";

import { StyledList, StyledListItem } from "./styles";

type Props = {
    filters: readonly CrmEnrichmentJobFilterType[];
    isApplyFiltersSelected: boolean | null;
    selectedJobObject: CrmEnrichmentJobObject | "";
    translationKeys: CrmEnrichmentI18nKeys;
};

const CrmEnrichmentJobReviewFilters = ({
    translationKeys,
    filters,
    isApplyFiltersSelected,
    selectedJobObject,
}: Props) => {
    const translate = useTranslation();

    const getFilterText = ({
        field,
        operator,
        multiValue,
        singleValue,
        selectedMultiValues,
        pickListItems,
    }: CrmEnrichmentJobFilterType): string => {
        const operatorText = translate(translationKeys.operator(operator as Operator))?.toLowerCase();

        if (crmEnrichmentFiltersService.isNoValueOperator(operator)) {
            return `${field} ${operatorText}`;
        }

        let valueText;

        if (pickListItems.length) {
            valueText = crmEnrichmentFiltersService.getSelectedMultiValuesFullText(selectedMultiValues);
        } else {
            valueText = crmEnrichmentFiltersService.isSingleSelectOperator(operator)
                ? singleValue
                : multiValue.join(", ");
        }

        return `${field} ${operatorText} ${valueText}`;
    };

    if (isApplyFiltersSelected) {
        return (
            <StyledList>
                {filters.map((filter) => (
                    <StyledListItem key={filter.field}>
                        <Text
                            fontVariant="report"
                            color={colorsPalettes.carbon[500]}
                            data-automation="filters-item"
                            data-automation-field={filter.field}
                        >
                            {getFilterText(filter)}
                        </Text>
                    </StyledListItem>
                ))}
            </StyledList>
        );
    }

    return (
        <Text
            fontVariant="report"
            color={colorsPalettes.carbon[500]}
            data-automation="filters-all"
        >
            {translate(translationKeys.allEntriesFilter(selectedJobObject))}
        </Text>
    );
};

export default CrmEnrichmentJobReviewFilters;
